import { render } from "./FeaturedProductsCarousel.vue?vue&type=template&id=27e0474c"
import script from "./FeaturedProductsCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturedProductsCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__